module.exports = __webpack_public_path__ + "img/menuIcon1.4c0635e9.png";